import React from 'react'
import {Route, Routes} from 'react-router'
import RoutesList from './routes_list'

const RoutesHere: React.FC = function () {
  return (
    <Routes>
      {RoutesList.map(r => {
        const Component = r.element
        return <Route path={r.path} element={<Component />} key={r.path} />
      })}
    </Routes>
  )
}

export default RoutesHere
